var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppModal',{attrs:{"title":_vm.$t('burgerMenu.profile'),"show":_vm.show,"show-close":""},on:{"on-close-click":_vm.closeHandler,"on-click-outside":_vm.closeHandler}},[_c('ProfileDetails',{attrs:{"modal-view":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }